import React from 'react'
import Navbar from './../components/Navbar';
import HeroImage2 from './../components/HeroImage2';
import Footer from "../components/Footer";
import AboutContent from '../components/AboutContent';

const About = () => {
  return (
    <div>
      <Navbar />
      <HeroImage2 heading="ABOUT" text="I'm a freelancer Front-end Developer" />
      <AboutContent/>
      <Footer />
      
    </div>
  )
}

export default About
